import React from "react";
import styles from "./ShowImage.module.scss";
import Modal from "../modal/Modal";
interface ImagesProps {
  imagesModal: boolean;
  setImagesModal: (value: boolean) => void;
  images?: string[];
  image?: string;
}
const ShowImage: React.FC<ImagesProps> = ({
  imagesModal,
  setImagesModal,
  images,
  image,
}) => {
  return (
    <Modal
      title={"Məhsulun şəkilləri"}
      isOpen={imagesModal}
      onClose={() => setImagesModal(false)}
      footer={false}
    >
      <div className={styles.product_images}>
        {images ? (
          images?.map((img: any, idx) => {
            return (
              <div key={idx} className={styles.img}>
                <img src={img.image} alt="product" />
              </div>
            );
          })
        ) : (
          <div className={styles.img}>
            <img src={image} alt="product" />
          </div>
        )}
      </div>
    </Modal>
  );
};

export default ShowImage;
